import React from 'react'
import MaskInput from './MaskInput'


export interface MaskInputProps extends React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement> {
}


export default function PhoneInput(props: MaskInputProps ) {
    return (
     <MaskInput mask={'___________'} replacement={{ _: /\d/ }}  {...props} />
    )
}